/***
*
*   DASHBOARD
*   Template dashboard example demonstrating various components inside a view.
*
**********/

import React, { useEffect } from 'react';
import {Animate, Button } from 'components/lib';
import Axios from 'axios';
import LogoAstronautaListo from '../../assets/astronauta_listo.svg';

export function UserValidation(props){

  useEffect(() => {
    let referrer = window.performance.navigation.type
    if(referrer !== 0) {
        window.location.href = window.location.origin + '/dashboard';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('email');
    validate(email)
  }, []);

  async function validate(email){
    await Axios({
        method: 'PUT',
        url: '/api/user/validate',
        data: {email: email}
    });
  }

  return (
    <Animate type='pop'>
        <div style={{ textAlign: 'center', fontSize: '50px', marginTop: '80px', fontWeight: '700', color: 'var(--df-primary)' }}>
            ¡LISTO!
        </div>
        <div style={{ textAlign: 'center', fontSize: '23px', marginTop: '30px', color: 'var(--df-primary)' }}>
            Tu correo electrónico ha sido verificado con éxito
        </div>
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <img width={250} height={250} src={ LogoAstronautaListo } alt='Logo' />
        </div>
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <Button 
                color='brand'
                text={'Ir al Dashboard'} 
                rounded={20} 
                widthBrand
                url={window.location.origin + '/dashboard'}
            />
        </div>
    </Animate>
  );
}
